
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.5 18.993a.5.5 0 01-.5-.5V5.494a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v4a.5.5 0 01-1 0v-3.5H4v11.999l4.5.001a.5.5 0 010 1l-5-.001z"}}),_c('path',{attrs:{"d":"M1.5 21.994c-.827 0-1.5-.673-1.5-1.5v-17c0-.827.673-1.5 1.5-1.5h4.141A3.836 3.836 0 018.998-.001a3.86 3.86 0 013.366 1.995H16.5c.827 0 1.5.673 1.5 1.5v5.5a.5.5 0 01-1 0v-5.5a.5.5 0 00-.5-.5h-4.448a.5.5 0 01-.458-.3 2.814 2.814 0 00-1.561-1.501 2.804 2.804 0 00-2.165.044A2.82 2.82 0 006.41 2.695a.5.5 0 01-.458.3H1.5a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h7a.5.5 0 010 1h-7z"}}),_c('path',{attrs:{"d":"M6.5 8.994a.5.5 0 010-1h5a.5.5 0 010 1h-5zM6.5 11.994a.5.5 0 010-1h5a.5.5 0 010 1h-5zM6.5 14.994a.5.5 0 010-1h3a.5.5 0 010 1h-3zM17.648 24.004c-.666 0-1.327-.11-1.965-.328A6.125 6.125 0 0112 20.15v1.844a.5.5 0 01-1 0v-3.5a.5.5 0 01.5-.5H15a.5.5 0 010 1h-2.313a5.055 5.055 0 003.319 3.735 5.072 5.072 0 001.641.274c.776 0 1.527-.176 2.232-.523a5.04 5.04 0 002.564-2.915.5.5 0 11.946.323 6.032 6.032 0 01-3.069 3.49 5.991 5.991 0 01-2.672.626zM20 16.994a.5.5 0 010-1h2.312a5.056 5.056 0 00-3.319-3.735 5.022 5.022 0 00-3.874.249 5.04 5.04 0 00-2.564 2.915.5.5 0 11-.946-.323 6.032 6.032 0 013.069-3.49 6.014 6.014 0 012.673-.625c.666 0 1.327.11 1.965.328a6.128 6.128 0 013.683 3.526v-1.844a.5.5 0 011 0v3.5a.5.5 0 01-.5.5H20z"}})])
          )
        }
      }
    